class RelatedSongs {
    constructor(data) {
        this.data = data;
    }

    get() {
        this.buildFilters();
        return this.filters;
    }

    buildFilters() {
        this.filters = {
            'user_id': App.user.id,
            'available_in': [App.user.country.id],
            'reviewed': false,
            'not_reviewed': false,
            'order_recent_by_publish_date': true,
            'randomize_by_day': false,
            'only_of_user': false,
            'gradually': true,
            'published': true,
            'uploader_id': window.temporarySong.uploader_id,
            'only_received_as_suggestion': false,
            'take': 5,
            'skip': (this.data.page - 1) * App.takeSongs,
        };
    }
}

export default RelatedSongs;
